import { Badge } from '#app/components/ui/badge.tsx'

export function PaidFeature() {
	return (
		<Badge variant="secondary" className="not-prose align-middle">
			Paid
		</Badge>
	)
}
